import { ROUTE_DASHBOARD } from '@/constants/routes';
import { registerWorkosAuth } from '@/services/workos-auth-bridge';
import { useAuth } from '@workos-inc/authkit-react';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const workosClientId = import.meta.env.VITE_WORKOS_CLIENT_ID;

/**
 * Redirects to WorkOS hosted login when the feature flag is enabled.
 * Only rendered when AuthKitProvider is present (VITE_WORKOS_CLIENT_ID is set).
 */
function WorkosSignInRedirect() {
  const { signIn, signOut, isLoading, user, getAccessToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (user) {
      // Already authenticated via WorkOS — register the bridge and redirect
      registerWorkosAuth(getAccessToken, signOut);
      navigate(ROUTE_DASHBOARD, { replace: true });
    } else {
      // Not authenticated — redirect to WorkOS hosted login
      signIn();
    }
  }, [user, isLoading, signIn, signOut, navigate, getAccessToken]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
    </div>
  );
}

export default function SignIn() {
  if (workosClientId) {
    return <WorkosSignInRedirect />;
  }

  return <Outlet />;
}
